import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Collapse
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

export const seoMeta = {
  title: 'Кръгли чаршафи с ластик за кръгъл матрак | 100% памук | GoToBed',
  description:
    'Кръгли чаршафи с ластик от 100% памук за кръгъл матрак. Диаметри 200, 210 и 220 см, височина 10-50 см. Ранфорс и памучен сатен. Поръчайте онлайн от GoToBed.'
};

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function SeoHeader() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Кръгли чаршафи с ластик за кръгъл матрак
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Кръгли чаршафи с ластик от 100% памук в голямо разнообразие от размери
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          В тази категория ще откриете кръгли чаршафи с ластик от 100% памук в богато разнообразие
          от размери – едно от основните предимства на нашия магазин. Предлагаме едноцветни модели и
          шарени десени с принт, подходящи за различни стилове спално бельо. Налични са размери с
          диаметър 200, 210 и 220 см, както и варианти за матраци с височина от 10 до 50 см.
        </Typography>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}

export default function SeoBody() {
  return <SeoBodyKrugliCharshafi />;
}

function SeoBodyKrugliCharshafi() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      {/* H2: Кръгли чаршафи с ластик за кръгъл матрак */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Кръгли чаршафи с ластик за кръгъл матрак
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Кръглите чаршафи с ластик за кръгъл матрак са практично решение за легла и матраци с
        нестандартна форма. Ако имате кръгло легло или кръгъл матрак, стандартните чаршафи често не
        прилягат добре, свличат се или се набират по време на сън. Затова най-доброто решение е
        чаршаф за кръгъл матрак, изработен точно по размера на вашето легло.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        В GoToBed можете да поръчате кръгъл чаршаф с ластик, изработен по индивидуални размери. Така
        чаршафът прилепва идеално към матрака и остава стабилен през цялата нощ. При поръчка
        избирате както диаметъра, така и височината на матрака, което гарантира перфектно прилягане.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        Ако търсите и други продукти за спалнята, можете да разгледате:
      </Typography>
      <Box sx={{ mb: 4, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/kategorii/spalno-belio/charshafi/1/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          чаршафи
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/kategorii/spalno-belio/charshafi-s-lastik/1/3"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          чаршафи с ластик
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/kategorii/spalno-belio/plikove-za-zavivka/1/4"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          пликове за завивки
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/kategorii/spalno-belio/kalufki/1/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          калъфки за възглавници
        </Typography>
      </Box>

      <Collapse in={expanded} collapsedSize={0}>
        {/* H2: Размери на кръгли чаршафи с ластик */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Размери на кръгли чаршафи с ластик
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Предлагаме кръгли чаршафи с ластик за матраци със следните диаметри:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {['кръгъл чаршаф 200 см', 'кръгъл чаршаф 210 см', 'кръгъл чаршаф 220 см'].map((size) => (
            <Typography key={size} variant="body1" sx={{ color: 'text.secondary' }}>
              {size}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Освен диаметъра можете да изберете и височината на матрака. Чаршафите са подходящи за
          матраци с височина:
        </Typography>
        <Box component="ul" sx={{ mb: 2, pl: 4, color: 'text.secondary' }}>
          <li>10–15 см</li>
          <li>16–20 см</li>
          <li>21–25 см</li>
          <li>26–30 см</li>
          <li>31–40 см</li>
          <li>41–50 см</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Благодарение на ластика по целия ръб чаршафът обхваща стабилно матрака и остава на мястото
          си по време на сън.
        </Typography>

        {/* H2: Как да изберете правилната височина на чаршафа */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Как да изберете правилната височина на чаршафа
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          При избора на височина е важно да прецените дали искате чаршафът да приляга точно по
          матрака или да има допълнителна дължина, за да може да се подпъхва под него.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Ако предпочитате да подпъхвате чаршафа под матрака, изберете малко по-голяма височина от
          реалната височина на матрака. Така ще има достатъчно плат, който да се прибере под матрака
          и чаршафът ще стои още по-стабилно.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Например:
        </Typography>
        <Box component="ul" sx={{ mb: 2, pl: 4, color: 'text.secondary' }}>
          <li>при матрак с височина 20 см → можете да изберете 21–25 см</li>
          <li>при матрак с височина 25 см → можете да изберете 26–30 см</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Ако предпочитате чаршафът да приляга точно по формата на матрака, изберете височина, която
          съответства на реалната височина.
        </Typography>

        {/* H2: Материи – 100% памук */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Материи – 100% памук
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Всички кръгли чаршафи с ластик за кръгъл матрак се изработват от висококачествени памучни
          материи – ранфорс и памучен сатен, изработени от 100% памук и сертифицирани по OEKO-TEX
          Standard 100.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Тези материи са дишащи, меки и приятни на допир, което ги прави подходящи за ежедневна
          употреба и комфортен сън през всички сезони.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Предлагаме два вида плат:
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Кръгли чаршафи с ластик ранфорс
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Ранфорсът е плътен и издръжлив памучен плат, който е много подходящ за чаршафи за кръгъл
          матрак, предназначени за ежедневна употреба и често пране.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Разгледайте нашите{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/krugli-sharshafi-s-lastik/1/6/2"
            sx={seoLinkStyle}>
            кръгли чаршафи с ластик ранфорс
          </Typography>
          , както и да ги комбинирате с{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/plikove-za-zavivka/1/4/2"
            sx={seoLinkStyle}>
            пликове за завивки ранфорс
          </Typography>{' '}
          и{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/kalufki/1/2/2"
            sx={seoLinkStyle}>
            калъфки ранфорс
          </Typography>
          , за да създадете напълно съчетан комплект спално бельо.
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mt: 2, mb: 1 }}>
          Кръгли чаршафи с ластик памучен сатен
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Памучният сатен е по-фин и гладък памучен плат с лек естествен блясък и по-мека текстура.
          Той осигурява по-деликатно и приятно усещане при допир и е предпочитан избор за
          по-луксозно спално бельо.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Ако предпочитате по-гладка материя, можете да изберете{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/krugli-sharshafi-s-lastik/1/6/1"
            sx={seoLinkStyle}>
            кръгли чаршафи с ластик памучен сатен
          </Typography>
          , както и да ги комбинирате с{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/plikove-za-zavivka/1/4/1"
            sx={seoLinkStyle}>
            пликове за завивки памучен сатен
          </Typography>{' '}
          и{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/kalufki/1/2/1"
            sx={seoLinkStyle}>
            калъфки памучен сатен
          </Typography>
          .
        </Typography>

        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Ластикът е поставен по целия ръб на чаршафа, което позволява той да прилепне стабилно към
          кръглия матрак и да остане на мястото си през цялата нощ.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Всеки кръгъл чаршаф с ластик се изработва индивидуално след направена поръчка, което
          гарантира точни размери и високо качество на изработката.
        </Typography>

        {/* H2: Допълнете спалното бельо */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Допълнете спалното бельо
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          За да завършите комплекта спално бельо за вашето легло, можете да комбинирате кръглия
          чаршаф с:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/plikove-za-zavivka/1/4"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            пликове за завивки
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/kalufki/1/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            калъфки за възглавници
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/charshafi/1/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/charshafi-s-lastik/1/3"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи с ластик
          </Typography>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Така можете да създадете напълно съчетан комплект спално бельо от една и съща материя и
          десен.
        </Typography>

        {/* H2: Предимства на нашите кръгли чаршафи с ластик */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Предимства на нашите кръгли чаршафи с ластик
        </Typography>
        <Box component="ul" sx={{ mb: 4, pl: 4, color: 'text.secondary' }}>
          <li>&#10004; изработка по индивидуален размер</li>
          <li>&#10004; диаметри 200 см, 210 см и 220 см</li>
          <li>&#10004; подходящи за матраци с височина 10–50 см</li>
          <li>&#10004; 100% памук – ранфорс или памучен сатен</li>
          <li>&#10004; OEKO-TEX Standard 100 сертификат</li>
          <li>&#10004; ластик по целия ръб за стабилно фиксиране</li>
          <li>&#10004; произведени в България</li>
        </Box>

        {/* H2: Срок за изработка */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Срок за изработка
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Всеки кръгъл чаршаф с ластик се изработва индивидуално по поръчка според избраните размери
          на матрака – диаметър и височина.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Срокът за изработка обикновено е между 3 и 10 работни дни, като в повечето случаи
          поръчките са готови в рамките на около 4–7 работни дни.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          След изработката поръчката се изпраща с куриер до посочения от вас адрес или до офис на
          куриерската фирма.
        </Typography>
      </Collapse>
      <Button
        onClick={() => setExpanded(!expanded)}
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          mb: 3,
          '&:hover': { backgroundColor: 'rgba(212, 175, 55, 0.08)' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>

      {/* H2: ЧЗВ */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 3 }}>
        Често задавани въпроси за кръгли чаршафи с ластик
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как да избера правилния размер кръгъл чаршаф с ластик?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            За да изберете подходящ кръгъл чаршаф с ластик, е необходимо да знаете диаметъра и
            височината на матрака. Тези два размера са достатъчни, за да се изработи чаршаф, който
            прилепва плътно към матрака и не се свлича по време на сън.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как се измерва кръгъл матрак за чаршаф?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Диаметърът на кръглия матрак се измерва като разстоянието от единия край до другия през
            центъра на матрака. Освен това трябва да измерите и височината на матрака – от основата
            до горната му повърхност. В нашия онлайн магазин предлагаме кръгли чаршафи с ластик за
            матраци с диаметър:
          </Typography>
          <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
            <li>200 см</li>
            <li>210 см</li>
            <li>220 см</li>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            За каква височина на матрака са подходящи кръглите чаршафи?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Кръглите чаршафи с ластик могат да се изработят за матраци с височина:
          </Typography>
          <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
            <li>10–15 см</li>
            <li>16–20 см</li>
            <li>21–25 см</li>
            <li>26–30 см</li>
            <li>31–40 см</li>
            <li>41–50 см</li>
          </Box>
          <Typography variant="body1" sx={{ mt: 1, color: 'text.secondary' }}>
            Изборът на правилна височина позволява чаршафът да обхване стабилно матрака и да остане
            на мястото си по време на сън.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Какъв чаршаф да избера за по-висок матрак?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Ако матракът е по-висок, е важно да изберете кръгъл чаршаф с достатъчна височина, за да
            може ластикът да обхване добре матрака. Например при матрак с височина 25 см е подходящ
            чаршаф с височина 26–30 см, особено ако искате да има допълнителна дължина за
            по-стабилно обхващане или подпъхване.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Трябва ли да избера по-голяма височина, ако искам чаршафът да се подпъхва?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Да. Ако желаете чаршафът да се подпъхва под матрака, е добре да изберете малко по-голяма
            височина от реалната височина на матрака. Така ще има достатъчно плат, който да се
            прибере под матрака. Например:
          </Typography>
          <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
            <li>при матрак 20 см → изберете 21–25 см</li>
            <li>при матрак 25 см → изберете 26–30 см</li>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Има ли стандартни чаршафи за кръгли матраци?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Кръглите матраци често са с нестандартни размери, затова стандартните чаршафи не винаги
            пасват добре. Затова нашите кръгли чаршафи с ластик се изработват по поръчка за диаметри
            200, 210 и 220 см, така че да прилягат идеално към матрака.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Свлича ли се чаршафът с ластик от кръгъл матрак?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Не. Ластикът е поставен по целия ръб на чаршафа, което позволява той да обхване стабилно
            матрака и да остане на мястото си през цялата нощ.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Какъв плат да избера – ранфорс или памучен сатен?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            И двата вида плат са изработени от 100% памук и осигуряват отличен комфорт по време на
            сън. Ранфорс – плътен и издръжлив памучен плат, подходящ за ежедневна употреба. Памучен
            сатен – фин, по-мек и гладък плат с лек блясък и по-луксозно усещане.
          </Typography>
          <Box sx={{ pl: 2 }}>
            <Typography
              variant="body1"
              component={Link}
              to="/produkti/spalno-belio/krugli-sharshafi-s-lastik/1/6/2"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              вижте кръгли чаршафи ранфорс
            </Typography>
            <Typography
              variant="body1"
              component={Link}
              to="/produkti/spalno-belio/krugli-sharshafi-s-lastik/1/6/1"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              вижте кръгли чаршафи памучен сатен
            </Typography>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Къде се изработват чаршафите?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Всички кръгли чаршафи с ластик се изработват в България, специално за всяка поръчка и
            според избраните размери на матрака.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            За колко време се изработва кръгъл чаршаф с ластик?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Тъй като чаршафите се изработват по индивидуални размери, срокът за изработка е между 3
            и 10 работни дни. В повечето случаи поръчките са готови за около 4–7 работни дни, след
            което се изпращат с куриер.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
